import { tdsFetch,tdPDF } from '@/utils/fetch';
import dayjs from 'dayjs';

const CACHE_ENABLE = true

const formatBody = (projectId, data) => {
  const { formData } = data
  return {
    projectTags: formData.field,
    projectCreator: formData.inventor,
    projectName: formData.title || null,
    value: JSON.stringify({ ...data, createTime: dayjs().format('YYYY-MM-DD HH:mm:ss') }),
    projectId,
    projectDept: formData.project,
  }
}
export const fetchSaveStep1 = (projectId, data) => {
  console.log('第一步需要保存的数据', data)
  return tdsFetch('/project/step1', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveStep1Cache = (projectId, data) => {
  if (!CACHE_ENABLE) return
  return tdsFetch('/project/step1/cache', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveStep2 = (projectId, data) => {
  console.log('第二步需要保存的数据', data)
  return tdsFetch('/project/step2', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveStep2Cache = (projectId, data) => {
  if (!CACHE_ENABLE) return
  return tdsFetch('/project/step2/cache', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveStep3 = (projectId, data) => {
  console.log('第三步需要保存的数据', data)
  return tdsFetch('/project/step3', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveStep3Cache = (projectId, data) => {
  if (!CACHE_ENABLE) return
  return tdsFetch('/project/step3/cache', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveStep4 = (projectId, data) => {
  console.log('第四步需要保存的数据', data)
  return tdsFetch('/project/step4', { method: 'PUT', body: formatBody(projectId, data) })
}

export const fetchSaveCompare = (data) => {
  return tdsFetch('/project/compare', { method: 'PUT', body: data })
}

// 点赞
export const fetchLike = (data) => {
  return tdsFetch('/project-praise/add', { method: 'POST', body: data })
}

// 文件提取的内容(文件、语音)
export const fetchSaveUploadValue = (data) => {
  return tdsFetch('/project/file/upload-value', { method: 'POST', body: data })
}

// 重写润色记录
export const fetchSaveActionValue = (data) => {
  return tdsFetch('/project-action/add', { method: 'POST', body: data })
}

// 保存模型
export const fetchSaveStepModel = (projectId, step, data) => {
  return tdsFetch('/project/step-model ', { method: 'PUT', body: { projectId, value: JSON.stringify(data), step } })
}

//报告查询接口
export const fetchReport = (data) => {
  return tdsFetch('/report/submit', { method: 'POST', body: data })
}

//状态查询接口
export const fetchStatus = (data) => {
 return tdsFetch('/report/status', { method: 'POST', body: data })
}

//取消查询接口
export const fetchCancel = (data) => {
 return tdsFetch('/report/cancel', { method: 'POST', body: data })
}

//一键删除接口
export const fetchClear = (data) => {
  return tdsFetch('/report/clear', { method: 'POST', body: data })
}

// 专利查询
export const forwardInvoke = (data) => {
  const queryParams = new URLSearchParams(data).toString();
  return tdsFetch(`/patentics/forward/invoke?${queryParams}`, { method: 'GET' })
}
//专利详情
export const fetchPatentDetail = (data) => {
  const queryParams = new URLSearchParams(data).toString();
  return tdsFetch(`/patentics/forward/xml?${queryParams}`, { method: 'GET' })
}



export const fetchSemanticsSearch = (data) => {
  return tdsFetch(`/incopat/semanticsSearch`, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}
export const fetchIncopatSearch = (data) => {
  return tdsFetch(`/incopat/incopatSearch`, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}
export const fetchPdfSearch = (data) => {
  return tdPDF(`/incopat/pdfStream`, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}
